// extracted by mini-css-extract-plugin
module.exports = {"areaStudyData":"index-areaStudyData-3dKeh","chartTitle":"index-chartTitle-10Em9"};